var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"area-message"},[_c('h5',[_vm._v(_vm._s(_vm.client.full_name))]),(_vm.chat_id)?_c('messages',{attrs:{"chat_id":_vm.chat_id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }